import React, {useEffect, useState} from 'react';
import TeamCalendarView from './TeamCalendarView';
import TeamEventList from './TeamEventList';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {TeamHeader} from "../organizations/teams/header/TeamHeader";
import {getOrganizationTeam} from "../../store/user_organizations/teams/team";
import {
  collabSetPanelViewRemember,
  getCnAData,
  setDatumIdOpen, setDatumIdOpenData
} from "../../store/user_organizations/teams/tools/connect_and_align";
import {Loading} from "../ui/loading/Loading";
import {getUserOrganizations} from "../../store/user_organizations";
import {CnAHeader} from "../organizations/teams/CnA/cna_header/CnAHeader";
import {CalendarHeader} from "./CalendarHeader";
import {zynity_website} from "../../config/external-routes";

export const TeamCalendarPage = () => {
  const dispatch = useDispatch();
  const [viewMode, setViewMode] = useState('calendar');
  const searchParams = new URLSearchParams(window.location.search);
  const teamIdParam = searchParams.get('team_id');
  const selectedTeam = useSelector((state) => state.selected_team);
  // Prefer team ID from URL, fallback to Redux state
  const teamId = searchParams.get('team_id') || selectedTeam?.id;
  const user_organizations = useSelector((state) => state.user_organizations);
  const [selected_organization_id, setSelected_organization_id] = useState(null);
  const organization_team = useSelector((state) => state.organization_team);
  const [loading, setLoading] = useState(true);
  const [selectedMember, setSelectedMember] = useState('team');
  const [showTeamFiles, setShowTeamFiles] = useState(false);
  const navigate = useNavigate();

  function findOrganizationIdByTeamId(data, targetTeamId ) {
    if (!data?.data?.data) return null;

    for (const organization of data.data.data) {
      const teamMatch = organization.teams.find(team => team.id == targetTeamId);
      if (teamMatch) {
        return organization.id;
      }
    }

    return null; // Si no se encuentra ningún equipo con ese ID
  }

  useEffect(() => {
    setLoading(true)
    dispatch( getUserOrganizations() );
  }, [])

  useEffect(() => {
    if(user_organizations.isLoading === false && teamId) {
      setSelected_organization_id(findOrganizationIdByTeamId(user_organizations, teamId))
    }

  }, [user_organizations])

  useEffect(() => {
    if(selected_organization_id != null && teamId != null) {
      setLoading(true)
      dispatch( getOrganizationTeam({organization_id: selected_organization_id, team_id: teamId}) );
      dispatch(getCnAData({organization_id: selected_organization_id, team_id: teamId}))
    }
  }, [selected_organization_id, teamId])

  if(loading && organization_team.isLoading === false && user_organizations.isLoading === false) {
    setLoading(false)
  }

  if(loading || teamId == null || selected_organization_id == null) {
    return <Loading />
  }

  const changePanelViewHandle = (panel) => {
    const user_organizations_obj = user_organizations.data?.data
    let organization = user_organizations_obj.filter((item) => item.id == selected_organization_id)[0];
    let organization_teams = organization.teams;

    let selected_team = organization_teams.find((team) => team.id == teamId)

    if(selected_team.Suite == 'Executive') {
      setShowTeamFiles(false)
      setSelectedMember(panel)

      if(panel == 'coach_notes')
        return true;

      let rememberData = {
        organization_id: parseInt(selected_organization_id),
        team_id: parseInt(teamId),
        view: panel == 'team' ? 'team' : 'member'
      }
      if(panel != 'team') {
        rememberData.user_id = parseInt(panel)
      }
      dispatch(collabSetPanelViewRemember(rememberData))
      navigate(`/organizations/${selected_organization_id}/teams/${teamId}/collab`)
    } else {
      //Suites available only in Yii version
      return goToYiiTools(selected_organization_id, teamId)
    }

    return false
  }

  const goToYiiTools = (org_id, team_id) => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${zynity_website.yii_website_url}/userHome/index`;
    const orgIdInput = document.createElement('input');
    orgIdInput.type = 'hidden';
    orgIdInput.name = 'orgId';
    orgIdInput.value = String(org_id);

    const teamIdInput = document.createElement('input');
    teamIdInput.type = 'hidden';
    teamIdInput.name = 'teamId';
    teamIdInput.value = String(team_id);

    const teamActionInput = document.createElement('input');
    teamActionInput.type = 'hidden';
    teamActionInput.name = 'teamAction';
    teamActionInput.value = String("goToTools");

    form.appendChild(orgIdInput);
    form.appendChild(teamIdInput);
    form.appendChild(teamActionInput);
    document.body.appendChild(form);
    form.submit();
    return false
  }

  const redirectToTool = () => {
    changePanelViewHandle('team')
  }

  return (
      <>
        <TeamHeader
            suffixRoute='/collab'
            selected_team_id={teamId}
            selected_organization_id={selected_organization_id}
        />

        <CalendarHeader setSelectedMember={changePanelViewHandle} selectedMember={selectedMember} setShowTeamFiles={setShowTeamFiles} redirectToTool={redirectToTool}/>

        <div className="container mt-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2>Team Calendar</h2>
            <div>
              <button
                  className={`btn me-2 ${viewMode === 'calendar' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setViewMode('calendar')}
              >
                📅 Calendar View
              </button>
              <button
                  className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setViewMode('list')}
              >
                📋 List View
              </button>
            </div>
          </div>

          {viewMode === 'calendar'
              ? <TeamCalendarView teamId={teamId} />
              : <TeamEventList teamId={teamId} />}

        </div>
      </>
  );
};
